import { truncateSelectedValues, formatSelectionsArray } from './utils'
import { bodyTypesData } from '@cinch-nx/data-search'

export const getFormattedBodyType = (bodyTypeSelections: string[] = []) =>
  truncateSelectedValues(
    formatSelectionsArray(bodyTypeSelections, bodyTypesData),
  )
